import { render, staticRenderFns } from "./StaffView.vue?vue&type=template&id=b04a55d0&scoped=true"
import script from "./StaffView.vue?vue&type=script&lang=js"
export * from "./StaffView.vue?vue&type=script&lang=js"
import style0 from "./StaffView.vue?vue&type=style&index=0&id=b04a55d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b04a55d0",
  null
  
)

export default component.exports